export const ResidentsFeedbackController = ['$scope', '$http', 'modalFactory', '$sce', function($scope, $http, $modal, $sce) {

    $scope.showFeedbackModal = function(post_id, trackingCode) {
        $scope.post_id = post_id;
        if(typeof trackingCode !== 'undefined'){
            $scope.trackingCodeSantized = $sce.trustAsHtml(trackingCode);
        }
        else{
            $scope.trackingCodeSantized = $sce.trustAsHtml('');
        }
        $modal.create($scope, angular.element(document.body), '/wp-content/themes/richman/components/modal/residentFeedbackModal.html');
    }

    $scope.feedbackSubmit = function(valid, data){
        if (valid){
            // console.log('valid ' , valid);
            $scope.feedbackProcess(data);
        } else {
            $scope.showErrors = true;
        }
    };

    $scope.feedbackProcess = function(data) {
        $scope.feedbackState = 'loading'
        $scope.message = ""
        // console.log('$scope.post_id ' , $scope.post_id);
        $http({
            method: 'POST',
            url: '/wp-json/richman/v1/feedback-form',
            data: {
                form: data,
                post_id: $scope.post_id
            }
        }).then(function successCallback(response) {
            // console.log('response ' , response);
            $scope.feedbackState = 'success'
            $scope.message = "Thanks for reaching out! We will be in touch shortly."
            $scope.showErrors = false;
            $scope.feedbackInputs = {};
            // this callback will be called asynchronously
            // when the response is available
        }, function errorCallback(response) {
            $scope.feedbackState = 'error'
            // console.log('error response ' , response);
            // called asynchronously if an error occurs
            // or server returns response with an error status.
        });
    };
}];